import React from "react";
import { Paper } from "@material-ui/core";
import { primary, red, yellow, green, darkBlue } from "../../styles/colors";

const SummaryCard = ({ label, value, subtext, icon, config }) => (
  <Paper
    elevation={0}
    className="summary-card-animated"
    style={{
      flex: 1,
      minWidth: 0,
      padding: "16px 12px",
      borderRadius: "8px",
      backgroundColor: config?.bg || "#f8f9fa",
      boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
      transition: "transform 0.2s, box-shadow 0.2s",
      cursor: "pointer",
    }}
  >
    <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "8px" }}>
      <div
        style={{
          width: "32px",
          height: "32px",
          borderRadius: "8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: config?.iconBg || darkBlue,
        }}
      >
        {icon}
      </div>
      <span
        style={{
          fontSize: "0.75rem",
          color: "#6c757d",
          textTransform: "uppercase",
          letterSpacing: "0.5px",
          fontWeight: 500,
        }}
      >
        {label}
      </span>
    </div>
    <div
      style={{
        fontSize: "1.5rem",
        fontWeight: 700,
        lineHeight: 1.2,
        color: config?.color || darkBlue,
      }}
    >
      {value}
    </div>
    {subtext && (
      <div
        style={{
          fontSize: "0.7rem",
          color: "grey",
          marginTop: "4px",
        }}
      >
        {subtext}
      </div>
    )}
  </Paper>
);

const SummaryCards = ({ summary = {}, paymentsCount = 0, activeFilter='all' }) => {
  const cardConfig = {
    total: {
      bg: "rgba(30, 53, 89, 0.08)",
      iconBg: darkBlue,
      color: darkBlue,
    },
    overdue: {
      bg: "rgba(220, 53, 69, 0.08)",
      iconBg: red,
      color: red,
    },
    urgent: {
      bg: "rgba(255, 193, 7, 0.15)",
      iconBg: yellow,
      color: "#856404",
    },
    savings: {
      bg: "rgba(40, 167, 69, 0.08)",
      iconBg: green,
      color: green,
    },
  };

  const MoneyIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z"/>
    </svg>
  );

  const WarningIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
      <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
    </svg>
  );

  const ClockIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
      <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
    </svg>
  );

  const SavingsIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
    </svg>
  );

  const formatCurrency = (amount) => {
    const num = parseFloat(amount) || 0;
    if (num >= 100000) {
      return `₹${(num / 10000000).toFixed(1)}Cr`;
    }
    return `₹${num.toLocaleString("en-IN")}`;
  };

  const fetchSummaryTabWise = (tabValue, key, summary) => {
    console.log(tabValue, key, summary);
    if(tabValue == 0) {
      return key === 'total'
      ? summary?.totalAmount
      : key === 'paid'
      ? summary?.totalPaidAmount
      : summary?.totalDue
    }
    else if(tabValue == 1){
      return key === 'total'
      ? summary?.apiSummary?.miller?.total_payable_amount
      : key === 'paid'
      ? summary?.apiSummary?.miller?.total_paid_amount
      : summary?.apiSummary?.miller?.total_pending_amount

    }
    else if(tabValue == 2){
      return key === 'total'
      ? summary?.apiSummary?.broker?.total_payable_amount
      : key === 'paid'
      ? summary?.apiSummary?.broker?.total_paid_amount
      : summary?.apiSummary?.broker?.total_pending_amount
    }
    else if(tabValue == "transporter"){
      return key === 'total'
      ? summary?.apiSummary?.transporter?.total_payable_amount
      : key === 'paid'
      ? summary?.apiSummary?.transporter?.total_paid_amount
      : summary?.apiSummary?.transporter?.total_pending_amount
    }

  }

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        gap: "16px",
        marginBottom: "20px",
      }}
    >
      <SummaryCard
        label="Total Amount"
        value={formatCurrency(fetchSummaryTabWise(activeFilter, 'total', summary))}
        subtext={`Total amount`}
        icon={<MoneyIcon />}
        config={cardConfig.total}
      />
      <SummaryCard
        label="Paid Amount"
        value={formatCurrency(fetchSummaryTabWise(activeFilter, 'paid', summary))}
        subtext={`Paid amount`}
        icon={<SavingsIcon />}
        config={cardConfig.savings}
      />
      <SummaryCard
        label="Total Due"
        value={formatCurrency(fetchSummaryTabWise(activeFilter, 'due', summary))}
        subtext={`${paymentsCount} payments pending`}
        icon={<WarningIcon />}
        config={cardConfig.overdue}
      />
      {/* <SummaryCard
        label="Overdue"
        value={summary?.overdueCount ?? 0}
        subtext="Requires immediate attention"
        icon={<WarningIcon />}
        config={cardConfig.overdue}
      />
      <SummaryCard
        label="Urgent"
        value={summary?.urgentCount ?? 0}
        subtext="Due within 3 days"
        icon={<ClockIcon />}
        config={cardConfig.urgent}
      />
      <SummaryCard
        label="Potential Savings"
        value={formatCurrency(summary?.potentialSavings)}
        subtext="Early payment discount"
        icon={<SavingsIcon />}
        config={cardConfig.savings}
      /> */}
    </div>
  );
};

export default SummaryCards;
